jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});
$('.noEnterSubmit').keypress(function(e){
    if ( e.which == 13 ) return false;
    //or...
    if ( e.which == 13 ) e.preventDefault();
});


$(document).ready(function(){

      $('#mainActive').addClass('active');
      $('#main3').fadeOut();
    $('#main2').fadeOut();
   $('#main1').fadeOut();
  $('#box1').click(function(){
   $('#box1').addClass('active');
    $('#main1').fadeIn();
     $('#main3').fadeOut();
    $('#mainActive').fadeOut();
    $('#main2').fadeOut();
     $('#box2').removeClass('active');
    $('#box3').removeClass('active');
     $('#mainActive').removeClass('active');

  });

  
   //  $('#box1').addClass('active');
   //    $('#main3').fadeOut();
   //  $('#main2').fadeOut();
   // $('#mainActive').fadeOut();
  $('#box1').click(function(){
   $('#box1').addClass('active');
    $('#main1').fadeIn();
     $('#main3').fadeOut();
    $('#mainActive').fadeOut();
    $('#main2').fadeOut();
     $('#box2').removeClass('active');
    $('#box3').removeClass('active');

  });
  $('#box2').click(function(){
     $('#box2').addClass('active');
    $('#main2').fadeIn();
    $('#main3').fadeOut();
    $('#mainActive').fadeOut();
    $('#main1').fadeOut();
      $('#box1').removeClass('active');
    $('#box3').removeClass('active');
  
   
  });
  $('#box3').click(function(){
      $('#box3').addClass('active');
    $('#main2').fadeOut();
    $('#main1').fadeOut();
      $('#main3').fadeIn();
    $('#mainActive').fadeOut();
       $('#box1').removeClass('active');
    $('#box2').removeClass('active');


     // Get today's date in the format "YYYY-MM-DD"
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      
      var currentDate = new Date();
      
      // Get the current month and day
      var currentMonth = months[currentDate.getMonth()];
      var currentDay = currentDate.getDate();
      
      // Format the date as 'Month Day'
      var formattedDate = currentMonth + ' ' + currentDay;
      
      console.log("Formatted date:", formattedDate);

  // Check if box3 (Days tab) is clicked

    
    var todayEvents = false; // Flag to track if there are events for today
    // Loop through each event info
    $('#main3 .events-info').each(function() {
      // Get the date of the event
      var eventDate = $(this).find('.dt-p').text().split('@')[0].trim();
      console.log(eventDate);
      // Check if the event date matches today's date
      if (eventDate === formattedDate) {
        $('#main3').show(); // Show the main3 section
        $(this).closest('.evnts-sec').show(); // Show the section containing the event
        $(this).show(); // Show the event
        todayEvents = true; // Set flag to true since there are events for today
      } else {
        $(this).hide(); // Hide the event
      }
    });

    // If there are no events for today, display "NO EVENTS TODAY"
    if (!todayEvents) {
      $('#main3').html('<p class="No-data">No events scheduled for Today</p>').show(); // Show the main3 section with the message
    }

});
   
 
});
  
